// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1M9Ys","title":"ClientInsurance_title__2552L","itemText":"ClientInsurance_itemText__Dn-fB"};